module.exports = __webpack_public_path__ + "img/logo.33d24e8b.png";